import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import "@uiw/react-md-editor/markdown-editor.css"
import "@uiw/react-markdown-preview/markdown.css"
import { lazy, Suspense } from 'react'
import ImageUploading, { ImageListType } from "react-images-uploading"

const MDEditor = lazy(() => import("@uiw/react-md-editor"))

export default function BlogEditor() {
  const [value, setValue] = useState<string | undefined>("**Hello world!!!**")
  const [images, setImages] = useState<ImageListType>([])
  const maxNumber = 69

  const onChange = (
    imageList: ImageListType,
    addUpdateIndex: number[] | undefined,
  ) => {
    // data for submit
    console.log(imageList, addUpdateIndex)
    setImages(imageList)
  }

  return (
    <>
      <Helmet>
        <title>Blog Szerkesztő | BeArt Művészetterápia</title>
        <meta name="description" content="Blog szerkesztő" />
        <link rel="canonical" href="https://beart.hu/blog/editor" />
      </Helmet>
      
      <div className="beart-section">
        <h1 className="beart-title">Blog Szerkesztő</h1>

        <h2 className="beart-title">Képkezelő</h2>
        <ImageUploading
          multiple
          value={images}
          onChange={onChange}
          maxNumber={maxNumber}
          dataURLKey="data_url"
        >
          {({
            imageList,
            onImageUpload,
            onImageRemoveAll,
            onImageUpdate,
            onImageRemove,
            isDragging,
            dragProps,
          }) => (
            // write your building UI
            <div className="upload__image-wrapper">
              <button
                style={isDragging ? { color: "red" } : undefined}
                onClick={onImageUpload}
                {...dragProps}
                className="rounded-md border-2 border-dashed border-gray-300 p-4"
              >
                Kattints ide vagy húzd ide a képeket!
              </button>
              &nbsp;
              <button
                className="m-2 rounded-md bg-red-500 p-2 text-white hover:bg-red-900"
                onClick={onImageRemoveAll}
              >
                Összes kép törlése
              </button>
              <div className="flex">
                {imageList.map((image, index) => (
                  <div
                    key={index}
                    className="image-item m-2 rounded-md border-2 border-gray-900 bg-gray-100 p-2"
                  >
                    <img
                      src={image["data_url"]}
                      alt=""
                      width="100"
                      className="mx-auto"
                    />
                    <div className="image-item__btn-wrapper">
                      <button
                        className="m-2 rounded-md bg-green-500 p-2 text-white hover:bg-green-900"
                        onClick={() => onImageUpdate(index)}
                      >
                        <i className="bi bi-arrow-repeat"></i> Frissítés
                      </button>
                      <button
                        className="m-2 rounded-md bg-red-500 p-2 text-white hover:bg-red-900"
                        onClick={() => onImageRemove(index)}
                      >
                        <i className="bi bi-trash"></i> Törlés
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </ImageUploading>

        <h2 className="beart-title">Szerkesztő</h2>
        <Suspense fallback={<div>Betöltés...</div>}>
          <MDEditor value={value} onChange={setValue} />
        </Suspense>
      </div>
    </>
  )
}
